import React, { useMemo } from 'react';

import { Tooltip } from '@/shared/components/tooltip';

import { cn } from '@/lib/utils';

import { useRichTextEditor } from '../rich-text-editor-provider';
import { variableMentionClasses, variablePillClasses } from './variable-pill-classes';

type VariablePillProps = {
	label: string;
	prefix?: string;
	className?: string;
};

export const VariablePill: React.FC<VariablePillProps> = ({ label, prefix, className }) => {
	const { getVariableTooltipFromToken, editable, showVariableBrackets, variableMentionStyle } =
		useRichTextEditor();

	const tooltip = useMemo(() => {
		return getVariableTooltipFromToken(`{${label}}`);
	}, [label]);

	if (variableMentionStyle) {
		const mention = <span className={cn(variableMentionClasses, className)}>{prefix ?? '@'}{label}</span>;
		if (tooltip && editable) return <Tooltip text={tooltip}>{mention}</Tooltip>;
		return mention;
	}

	const displayText = showVariableBrackets ? `{${label}}` : label;

	const content = (
		<span className={cn(variablePillClasses, className, !editable && 'text-muted-foreground/80')}>
			{displayText}
		</span>
	);

	if (tooltip && editable) return <Tooltip text={tooltip}>{content}</Tooltip>;

	return content;
};
